import { render, staticRenderFns } from "./PointsSet.vue?vue&type=template&id=6be81d2f"
import script from "./PointsSet.vue?vue&type=script&lang=js"
export * from "./PointsSet.vue?vue&type=script&lang=js"
import style0 from "./PointsSet.vue?vue&type=style&index=0&id=6be81d2f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports